
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reference/ux/sort",
      function () {
        return require("private-next-pages/reference/ux/sort.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reference/ux/sort"])
      });
    }
  